import React, { Component } from 'react';
import { Layout, Col, Row, Form, Input, Button, Alert, Typography, Spin, Space } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import api from '../lib/api';
import { ADMIN_URL } from '../constants/settings';
import '../App.css';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";

// const axios = require('axios').default;

class OccupantLogin extends Component {

  constructor(props) {

    super(props);

    this.state = {
      loading: true,
      loginError: false,
      loginLoading: false,
      identity: this.props.identity || null,
      show_password: false,
      show_sso_button: false
    };
  }

  componentDidMount() {

    localStorage.clear();

    if(this.state.identity.show_login_sso_button !== 1)
    {   // no sso button, so always show the password field
        this.setState({ show_password: true, show_sso_button: false });
    }
    else
    {
      if(!this.state.identity.sso_domains)
      {   // no specific sso domains, so always show the button
          this.setState({ show_password: true, show_sso_button: true });
      }
    }
  }

  login = (values) => {

    this.setState({loginError: false, loginLoading:true});

    api('post','login', {'email': values.username, 'password': values.password}, false).then((response) => {

      if(response && response.data.token) {
        window.location.replace(" " + ADMIN_URL + "/login/token/" + response.data.token);
      }
      else
      {
        this.setState({loginError: true, loginLoading:false})
      }
    });
  }

  usernameChanged(value)
  {
      if(this.state.identity.show_login_sso_button === 1 && this.state.identity.sso_domains)
      {
          value = value.toLowerCase();

          var value_splitted = value.split('@');

          var domain = value_splitted[value_splitted.length - 1];

          var sso_domains = this.state.identity.sso_domains.split(',');

          sso_domains = sso_domains.map(sso_domain => sso_domain.toLowerCase());

          if(sso_domains.includes(domain) && this.emailIsValid(value))
          {
              this.setState({ show_sso_button: true, show_password: false });
          }
          else if(this.emailIsValid(value))
          {
              this.setState({ show_sso_button: false, show_password: true });
          }
          else
          {
              this.setState({ show_sso_button: false, show_password: false });
          }
      }
  }

  emailIsValid (email)
  {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  render() {
    const { Title, Paragraph } = Typography;

    return (
      <Row type="flex" style={{ height: "100%", flexDirection: "column", justifyContent: "space-between"}}>
        <Col>
          <img style={{width: 200, marginBottom: 48}} src={this.state.identity.logo_url} />
        </Col>

        <Col>
            {this.state.identity && this.state.identity.show_login_form ? (
              <div style={{ marginBottom: '20px' }}>
                <Form onFinish={this.login} style={{ width: '100%', textAlign: 'middle', }}>

                  {/*<Alert style={{marginBottom: 10}} message="Let op!" type="error" description="Het Cobee systeem zal zaterdag 2 december door onderhoudswerkzaamheden niet beschikbaar zijn." />*/}

                  {this.state.loginError ? (
                    <Alert style={{marginBottom: 16}} message="Inloggen mislukt" type="error" description="Gebruikersnaam en/of wachtwoord onjuist" closable afterClose={() => this.setState({loginError: false})} />
                  ) : null}

                  <Title level={2}>Inloggen</Title>
                  <Paragraph>Log in met een gebruikersnaam en wachtwoord.</Paragraph>
                  <Form.Item
                    name="username"
                    style={{ marginBottom: '8px' }}
                    rules={[{ required: true, message: 'Vul een gebruikersnaam in'}]}
                  >
                    <Input prefix={<UserOutlined style={{ color: 'rgba(0, 0, 0, 0.25)' }} />} onChange={(event) => { this.usernameChanged(event.target.value); }} placeholder="Gebruikersnaam" />
                  </Form.Item>

                  { this.state.show_password && (<Form.Item
                    name="password"
                    style={{ marginBottom: '8px' }}
                    rules={[{ required: true, message: 'Vul een wachtwoord in' }]}
                  >
                    <Input.Password prefix={<LockOutlined style={{ color: 'rgba(0, 0, 0, 0.25)' }} />} type="password" placeholder="Wachtwoord" />
                  </Form.Item>)}

                  <Paragraph style={{ fontSize: '14px', }}>Door in te loggen ga je akkoord met onze <a target="_blank" href="https://www.cobee.nl/algemene-voorwaarden/">algemene voorwaarden</a>, <a target="_blank" href="https://www.cobee.nl/privacy/">privacybeleid</a> en <a target="_blank" href="https://www.cobee.nl/cookiebeleid/">cookiebeleid</a>.</Paragraph>
                  { this.state.show_password && (<Button style={{ width: '100%', margin: '16px 0 0 0' }} type="primary" htmlType="submit" loading={this.loginLoading}>
                    Inloggen
                  </Button>)}
                  <Link to="/wachtwoord-vergeten-beheer"><span style={{ display: 'block', margin: '16px 0 0 0'}}>Wachtwoord vergeten</span></Link>
                </Form>
                {/* <Button style={{ width: '100%', color: 'black', margin: '16px 0 0 0', background: '#' + this.state.identity.color_primary, borderColor: '#' + this.state.identity.color_primary}} onClick={this.login} type="primary">Inloggen</Button> */}
              </div>
            ) : null }

            {/*this.state.identity && this.state.identity.show_login_sso_button === 1 &&*/ this.state.show_sso_button && (
              <div>
                {/* <Button disabled={this.state.loginLoading} style={{ color: 'black', background: '#' + this.state.identity.color_primary, borderColor: '#' + this.state.identity.color_primary}} onClick={this.login} type="primary">Inloggen met SSO</Button> */}
                <Button disabled={this.state.loginLoading} href={this.state.identity.sso_button_url} type="primary">Inloggen met SSO</Button>
              </div>
            ) }

            <div>
                <Link to="/"><span style={{ display: 'block', margin: '16px 0 0 0'}}>Login voor bewoners</span></Link>
            </div>

          </Col>
        </Row>
    );

  }
}

export default OccupantLogin;
